import {
  Video,
  Film,
  Radio,
  BarChart3,
  Settings,
  Library,
  Scissors,
  Upload,
  List,
  Calendar,
  PlayCircle,
  Tv,
  ExternalLink,
  Archive,
  Image,
  Youtube,
  Layers,
  Database,
  ListVideo,
  Globe,
  Megaphone,
  Target,
  Users,
  Paintbrush,
  Smartphone,
  ShoppingBag,
  Table2,
  CalendarDays,
  ScrollText
} from 'lucide-react'

// External links (open in new tab)
export const externalLinks = {
  analytics: 'https://tbtv-analytics.pages.dev'
}

// Top-level navigation categories
export const topNavItems = [
  { id: 'video-library', label: 'Video Library', icon: Video, path: '/video-library' },
  { id: 'ondemand', label: 'On-Demand Library', icon: Film, path: '/ondemand' },
  { id: 'sources', label: 'Sources', icon: Database, path: '/sources' },
  { id: 'livestream', label: 'Live Stream', icon: Radio, path: '/livestream' },
  { id: 'sponsors', label: 'Sponsors', icon: Megaphone, path: '/sponsors' },
  { id: 'analytics', label: 'Analytics', icon: BarChart3, path: '/analytics', external: externalLinks.analytics },
  { id: 'settings', label: 'Settings', icon: Settings, path: '/settings' },
]

// Sidebar navigation for each category
export const sidebarNavItems = {
  'video-library': [
    { 
      id: 'stream-manager', 
      label: 'Stream Manager', 
      icon: Library, 
      path: '/video-library/stream-manager',
      description: 'Browse, edit, upload, and delete videos'
    },
    { 
      id: 'stream-editor', 
      label: 'Stream Editor', 
      icon: Scissors, 
      path: '/video-library/stream-editor',
      description: 'Trim and create clips from videos'
    },
    { 
      id: 'archive-manager', 
      label: 'Archive Manager', 
      icon: Archive, 
      path: '/video-library/archive-manager',
      description: 'Manage R2 video archive'
    },
    {
      id: 'mux-stream-manager',
      label: 'Mux Stream Manager',
      icon: PlayCircle,
      path: '/video-library/mux-stream-manager',
      description: 'Manage Mux.com video assets'
    },
    {
      id: 'mux-stream-editor',
      label: 'Mux Stream Editor',
      icon: Scissors,
      path: '/video-library/mux-stream-editor',
      description: 'Clip, thumbnail capture, GIF from Mux assets'
    },
    {
      id: 'image-manager',
      label: 'Image Manager',
      icon: Image,
      path: '/video-library/image-manager',
      description: 'Manage Cloudflare Images'
    },
    { 
      id: 'youtube-archive', 
      label: 'YouTube Archive', 
      icon: Youtube, 
      path: '/video-library/youtube-archive',
      description: 'Sync and manage YouTube video metadata'
    },
    { 
      id: 'bulk-upload', 
      label: 'Bulk Upload', 
      icon: Upload, 
      path: '/video-library/bulk-upload',
      description: 'Upload multiple videos at once'
    },
  ],
  'ondemand': [
    {
      id: 'catalog',
      label: 'Content Catalog',
      icon: List,
      path: '/ondemand/catalog',
      description: 'Manage on-demand content catalog'
    },
    {
      id: 'collections',
      label: 'Collections',
      icon: Film,
      path: '/ondemand/collections',
      description: 'Organize content into collections'
    },
    {
      id: 'highlights',
      label: 'Highlights',
      icon: Scissors,
      path: '/ondemand/highlights',
      description: 'Search captions and build clip reels'
    },
    {
      id: 'teams-data',
      label: 'Teams Data',
      icon: Users,
      path: '/ondemand/teams-data',
      description: 'Rosters, teams, future game stats + standings'
    },    {
      id: 'ticker-data',
      label: 'Ticker Data',
      icon: ScrollText,
      path: '/ondemand/ticker-data',
      description: 'Game summaries formatted for the streaming ticker'
    },
  ],
  'sources': [
    { 
      id: 'tbtv-channels', 
      label: 'TBTV Channels', 
      icon: Layers, 
      path: '/sources/tbtv-channels',
      description: 'Manage streaming channel lineup'
    },
    { 
      id: 'live-inputs', 
      label: 'Live Inputs', 
      icon: Radio, 
      path: '/sources/live-inputs',
      description: 'Manage Cloudflare Stream live inputs'
    },
     {
      id: 'tbtv-strimm',
      label: 'Strimm Partners',
      icon: ExternalLink,
      path: '/sources/tbtv-strimm',
      description: 'Browse partner HLS content libraries via Strimm'
    },
  ],
  'livestream': [
    { 
      id: 'schedule', 
      label: 'Live Schedule', 
      icon: Calendar, 
      path: '/livestream/schedule',
      description: 'Manage live stream schedule for watch.tenband.tv'
    },
    { 
      id: 'playlist-builder', 
      label: 'Playlist Builder', 
      icon: ListVideo, 
      path: '/livestream/playlist-builder',
      description: 'Build 24/7 linear playlists from Stream videos'
    },
    {
      id: 'ssai-manager',
      label: 'SSAI Manager',
      icon: Radio,
      path: '/livestream/ssai-manager',
      description: 'Server-Side Ad Insertion management and monitoring'
    },
    {
      id: 'streamer',
      label: 'Streamer',
      icon: Radio,
      path: '/livestream/streamer',
      description: 'Stream HLS to RTMP/SRT destinations'
    },
    {
      id: 'team-scheduler',
      label: 'Team Scheduler',
      icon: CalendarDays,
      path: '/livestream/team-scheduler',
      description: 'Full-season league game schedules — PIHL first'
    },
    {
      id: 'epg',
      label: 'EPG Manager',
      icon: Tv, 
      path: '/livestream/epg',
      description: 'Electronic Program Guide management'
    },
    { 
      id: 'live-now', 
      label: 'Live Now', 
      icon: PlayCircle, 
      path: '/livestream/live-now',
      description: 'Monitor current live streams'
    },
  ],
  'sponsors': [
    {
      id: 'sponsor-dashboard',
      label: 'Dashboard',
      icon: BarChart3,
      path: '/sponsors/dashboard',
      description: 'AdSpeed entity counts and recent activity'
    },
    {
      id: 'sponsor-zones',
      label: 'Zones',
      icon: Target,
      path: '/sponsors/zones',
      description: 'AdSpeed zones — inventory slots, weights, tbtv tags'
    },
    {
      id: 'sponsor-ads',
      label: 'Ads',
      icon: Film,
      path: '/sponsors/ads',
      description: 'AdSpeed ads — creative, linkage, weights'
    },
    {
      id: 'sponsor-groups',
      label: 'Groups',
      icon: Layers,
      path: '/sponsors/groups',
      description: 'AdSpeed groups — bundle ads into reusable buckets'
    },
    {
      id: 'sponsor-advertisers',
      label: 'Advertisers',
      icon: Users,
      path: '/sponsors/advertisers',
      description: 'AdSpeed advertisers — accounts, contact info, password'
    },
    {
      id: 'sponsor-campaigns',
      label: 'Campaigns',
      icon: Calendar,
      path: '/sponsors/campaigns',
      description: 'AdSpeed campaigns — read-only list (manage in AdSpeed dashboard)'
    },
    {
      id: 'sponsor-ad-builder',
      label: 'Ad Builder',
      icon: Paintbrush,
      path: '/sponsors/ad-builder',
      description: 'Configure 970×250 web ads served from the vader worker'
    },
    {
      id: 'sponsor-store',
      label: 'Sponsor Store',
      icon: ShoppingBag,
      path: '/sponsors/store',
      description: 'Shopify offers, ad placements, and sponsorship pricing on the public pages'
    },
  ],
  // Analytics is external - no sidebar items needed
  'analytics': [],
  'settings': [
    {
      id: 'site-settings',
      label: 'Site Settings',
      icon: Globe,
      path: '/settings/site-settings',
      description: 'Splash page content and branding'
    },
    {
      id: 'vod',
      label: 'VOD Settings',
      icon: Film,
      path: '/settings/vod',
      description: 'Preview position, playback settings'
    },
    {
      id: 'youtube',
      label: 'YouTube Settings',
      icon: Youtube,
      path: '/settings/youtube',
      description: 'Per-platform YouTube-only Live / On-Demand toggles'
    },
    {
      id: 'live',
      label: 'Live Events',
      icon: Radio,
      path: '/settings/live',
      description: 'Webhook wiring and live-input status'
    },
    {
      id: 'player',
      label: 'Player Settings',
      icon: PlayCircle,
      path: '/settings/player',
      description: 'Watch-mode player hero ads (LIVE / EPG / VOD)'
    },
    {
      id: 'roku',
      label: 'Roku Settings',
      icon: Tv,
      path: '/settings/roku',
      description: 'Search feed options, image migration, feed validator'
    },
    {
      id: 'apple',
      label: 'Apple Mobile Settings',
      icon: Smartphone,
      path: '/settings/apple',
      description: 'iOS app runtime settings (YouTube hand-off vs in-app)'
    },
    {
      id: 'api-keys',
      label: 'API Keys',
      icon: Settings,
      path: '/settings/api-keys',
      description: 'Manage API credentials'
    },
  ],
}

export function getActiveCategory(pathname) {
  for (const item of topNavItems) {
    if (pathname.startsWith(item.path)) {
      return item.id
    }
  }
  return 'video-library'
}
